import { unauthenticated, authenticated, refresh_token } from './WebRequest';
import type {
  ApiThunk,
  LoginPayload,
  LoginResponse,
  LoginTokenResponse,
} from './types/Login';

export type {
  ApiThunk,
  LoginPayload,
  LoginResponse,
  LoginTokenResponse,
  Nullable,
  TwoFactorLoginResponse,
} from './types/Login';

export class LoginAPI {
  login(payload: LoginPayload): ApiThunk<LoginResponse> {
    return unauthenticated.post<LoginResponse>('/auth', payload);
  }

  logout(): ApiThunk<string> {
    return authenticated.get<string>('/logout');
  }

  refresh_create(): ApiThunk<LoginTokenResponse> {
    return refresh_token.post<LoginTokenResponse>('/refresh/create');
  }

  refresh_confirm(payload: LoginTokenResponse): ApiThunk<LoginTokenResponse> {
    return refresh_token.post<LoginTokenResponse>('/refresh/confirm', payload);
  }
}

const api = new LoginAPI();

export { api as default };
